<template>
  <div class="xcard">
      <v-btn small class="mx-4" @click="$router.back()" color="info" rounded outlined> <v-icon>mdi-arrow-left-bold</v-icon> Volver Atras</v-btn>
    <h3 class="text-primary text-center">Ciudades</h3>
    <button class="btn btn-link btn-sm" @click="editar({})" v-show="$store.state.createCiudad" data-toggle="modal" data-target="#modal-nciudad"> <span class="glyphicon glyphicon-plus"></span> Ciudad </button> 
    

    <div class="table-responsive">
        <input v-show="datos.length" type="text" style="border:1px solid #1177d1;background:#fefefe" v-model="buscar" placeholder="Buscar...">                
      <table class="table table-hover" id="midatatable">
        <thead>
          <tr>
            <th>Nro</th>
            <th>Nombre</th>
            <th>Departamento</th>
            <th>Opciones</th>
          </tr>
        </thead>

        <tbody>
          <tr v-bind:key="ind" v-for="(sede, ind) in datos">
            <td>{{ ind + 1 }}</td>
            <td :title="'id:' + sede.id">{{ sede.nombre }}</td>
            <td>{{ parsedepa(sede.departamento) }}</td>
            <td style="min-width: 90px">
                <button class="btn btn-sm btn-link" @click="editar(sede)" v-show="$store.state.updateCiudad" data-toggle="modal" data-target="#modal-nciudad"> <span class="glyphicon glyphicon-pencil"></span> </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <Alertas ref="alertar" />
    <NewC v-on:exito="modalExitof" :edit="seleccionado"/>
  </div>
</template>



<script>
import gql from 'graphql-tag';
import { parseJsonError } from '@/components/Utils.js';
import Alertas from '@/components/AAlertas.vue';
import NewC from '@/components/ANewCiudad.vue'

export default {
  data() {
    return {
      datos: [],
      buscar:'',
      seleccionado:{},
    };
  },
  components: { Alertas,NewC },
  watch: {
    'buscar': function(){ this.myFunction1( this.buscar.trim() ) }
  },
  methods: {
      editar( obj ){
          this.seleccionado = obj;
      },
      modalExitof(){
          this.getDatos();
        },
      parsedepa(d){
          if( !d ) return '-';
          return d.nombre;
      },
    async getDatos() {
      this.$refs.alertar.cargando();
      var vue = this;
      var sql = gql`
      query{
        getCiudades(estado:true){id,nombre,estado,departamento{id,nombre,extension}}
        }`;
      await this.$apollo
        .query({
          query: sql,
        })
        .then(({data}) => {
          vue.datos = data.getCiudades;
          vue.$refs.alertar.reset();
        })
        .catch((error) => {
          // window.console.error(error);
          vue.$notify(parseJsonError(error, 'getCiudades'));
          vue.$refs.alertar.reset();
        });
    },
    myFunction1( filtro ) {
            filtro = filtro.toUpperCase();
            var table, tr, tdd,td, i,j, txtValue;
            table = document.getElementById("midatatable");
            tr = table.getElementsByTagName("tr");

            for (i = 0; i < tr.length; i++) {
                tdd = tr[i].getElementsByTagName("td");
                for(j = 1; j< tdd.length;j++) {
                    td = tdd[j];
                    if (td) {
                        txtValue = td.textContent;
                        if (txtValue.toUpperCase().indexOf(filtro) > -1) {
                            tr[i].style.display = "";
                            break;
                        } else {
                            tr[i].style.display = "none";
                        }
                    } 
                }
            }
		},
  },
  mounted() {
    this.getDatos();
  },
};
</script>